exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sliderVideoInfoWrapper {\n    touch-action: pan-y;\n}\n.sliderVideoInfo__playBtn svg {\n    max-width: 100%;\n}\n.device-mobile .sliderVideoInfo__playBtnWrapper {\n    display: none;\n}\n", ""]);

// exports
